export type ChatSearch = { frage?: string; gespraech?: string }
export function parseChatSearch(search: Record<string, unknown>): ChatSearch {
  return {
    frage:
      typeof search.frage === "string" && search.frage.trim()
        ? search.frage.trim().slice(0, 2000)
        : undefined,
    gespraech:
      typeof search.gespraech === "string" && search.gespraech.trim()
        ? search.gespraech.trim()
        : undefined,
  }
}

// Larsen reports window.location.href, so the question typed on the start page
// must not stay in the address once the chat has taken it over.
export function withoutQuestion<T extends { frage?: string }>(search: T): T {
  return { ...search, frage: undefined }
}
